<div>
    <p class="my-text">{{ getTextBuffer() }}</p>
    <span *ngIf="!readMore && getTextBuffer().length>0 && text.length>limit" class="read-more-text" (click)="readMore = !readMore">leer más</span>
    <span *ngIf="readMore" class="read-more-text" (click)="readMore = !readMore">leer menos</span>
</div>

